module.exports = __webpack_public_path__ + "static/img/image_menu_default.c9a9c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_menu_default.png
// module id = 364
// module chunks = 1